import Component from 'vue-class-component'
import Vue from 'vue'
import ReactButton from './ReactButton.vue'
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'loginButton',
  props: ['text']
})
export default class LoginButton extends Vue {

  protected login (): void {
    authStore.dispatchLogin()
  }

}
